import React from 'react';
import { Table ,Image , Row,Col,Button,Modal} from 'react-bootstrap';
import defaultAvatar from '../../assets/images/default_avatar.png'
import * as Icon from 'react-feather';

function formatDate(str) {
  return str.substr(0, 10);
}

function capitalize(str) {
  return str.split(' ').map(s => {
    return s.charAt(0).toUpperCase() + s.substr(1);
  }).join(' ');
}


class UserTableRow extends React.Component {
  state = { expanded: false }

  toggleExpander = (e) => {
    if (e.target.type === 'checkbox') return;

    if (!this.state.expanded) {
      this.setState(
        { expanded: true });
    } else {
      this.setState({ expanded: false });
    }
  }
  handleMessage =(message)=>{
    this.props.handleMessage(message)
  }

  render() {
    const { user } = this.props;
   
    return [
      
      <tr  >
        {this.props.header.map(({ key, name, requiredActions, icon }, index) => (
           
           <td
             scope="col"
             // style={{ padding: "10px 0px 10px 0px" }}
             // className="text-center"
             key={index}
           >
             {/* {user[`${key}`]} */}
             {key === 'content' ? (
               <>
               {user[`${key}`].length > 70 ? (
                 <> 
                 {user[`${key}`].substring(0,70)}
                  <span onClick={()=>{
                 this.handleMessage(user[`${key}`])
               }} className="text text-primary">see more</span>
               </>
               ): (
                 <>{user[`${key}`]}</>
               )}
               </>
             ) : (
                                                        <>
                                                        {user[`${key}`]}
                                                        </>
                                                      )}
           </td>
     ))}
      </tr>,
      this.state.expanded && (
        <tr className={`expandable ${this.state.expanded ? "grid-active" : null }`}  key="tr-expander">
          <td className="uk-background-muted" colSpan={this.props.header.length}>
          {/* <Row> 
                        <Col xl={12}>
                                    <Table responsive style={{border:"none !important"}} className="m-0">
                                        <thead>
                                            <tr>
                                            {this.props.nestedHeader.map(({ key, name }, index) => (
           
                                                    <td
                                                      scope="col"
                                                      // style={{ padding: "10px 0px 10px 0px" }}
                                                      // className="text-center"
                                                      key={index}
                                                    >
                                                      <b>{name}</b>
                                                    </td>
                                              ))}
                                            </tr>

                                        </thead>

                                        <tbody>
                                        <tr>
                                          
                                            {this.props.nestedHeader.map(({ key, name }, index) => (
           
                                                    <td
                                                      scope="col"
                                                      // style={{ padding: "10px 0px 10px 0px" }}
                                                      // className="text-center"
                                                      key={index}
                                                    >
                                                      {key === 'message' ? null : (
                                                        <>
                                                        {user[`${key}`]}
                                                        </>
                                                      )}
                                                      
                                                    </td>
                                              ))}
                                            </tr>
                                        </tbody>
                                    </Table>
                        </Col>
                    </Row> */}
          </td>
        </tr>
      )
    ];
  }
}



class NotificationTable extends React.Component {
  state = { users: null ,enablePopup:false,message:null}
  handleMessage=(message)=>{
    console.log(message)
    this.setState({
      enablePopup: true,
      message:message,
    })
  }
  handleClose=()=>{
    this.setState({
      enablePopup:false
    })
  }
  render() {
      console.log(this.props.data)
    const { users } = this.state;
    const isLoading = this.props.data.length === 0;
    

    return (
        <div >
          <Modal show={this.state.enablePopup} size="lg" onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              {this.state.message}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            Close
          </Button>
          
        </Modal.Footer>
      </Modal>
          {/* <div className="uk-overflow-auto"> */}
            <Table responsive >
            <thead style={{ 
        backgroundColor: "#1c5984" ,color:"#ffff"}}>
        <tr>
          {this.props.header.map(({ key, name, requiredActions, icon }, index) => (
           
                  <th
                    scope="col"
                    // style={{ padding: "10px 0px 10px 0px" }}
                    // className="text-center"
                    key={`${index}-${this.state.enablePopup}`} 
                  >
                    {name}
                  </th>
            ))}
           
        </tr>
      </thead>
              <tbody>
                {isLoading
                  ? <tr><td colSpan={6} className="uk-text-center"><em className="uk-text-muted">Loading...</em></td></tr>
                  : this.props.data.map((user, index) =>
                      <UserTableRow key={index} index={index + 1} user={user} header={this.props.header} nestedHeader={this.props.nestedHeader} handleMessage={this.handleMessage}/>
                    )
                }
              </tbody>
            </Table>
          {/* </div> */}
        </div>
    );
  }
}

export default NotificationTable;